import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useParams } from 'react-router-dom';
import ActivityTrackerDetailHeader from './ActivityTrackerDetailHeader';
import ActivityTrackerDetailContent from './ActivityTrackerDetailContent';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    height: '100vh',
  },
}));

interface Props {
  showCharts?: boolean;
}

const ActivityTrackerDetail: React.FC<Props> = ({ showCharts = false }) => {
  const classes = useStyles();
  const { patientId } = useParams();

  return (
    <div className={classes.root}>
      <ActivityTrackerDetailHeader patientId={patientId} />
      <ActivityTrackerDetailContent patientId={patientId} showCharts={showCharts} />
    </div>
  );
};

export default ActivityTrackerDetail;

